export const ARHITECTURE = 'arhitecture';
export const CIVILS = 'civils';
export const VEHICLE = 'vehicle';
export const ENERGY = 'energy';
export const LOCATION = 'location';
export const MAP = 'map';
